// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M_LWzogsO_zYvuPWWb56 {
  max-width: 50rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 50vh;
  padding-left: var(--horizontal-padding);
  padding-right: var(--horizontal-padding);
}

.Ti_7UHTcij_uY7oFppr1 {
  --bottom-padding: 2.5rem;

  padding-top: var(--top-padding);
  padding-bottom: var(--bottom-padding);
  color: var(--error-404-text-color);
}

.QhnOgzWcbQE7aDNH_VaU {
  padding-bottom: 2.5rem;
  min-width: 100%;
}

.E7WhznPcFeQeAyPuNB_8 {
  display: inline;
  font-size: 1rem;
}

.BEJ3qVWAC5B6xyDwF8XC {
  padding-bottom: 2.5rem;
}

@media only screen and
  (min-width: 1280px) {
  .M_LWzogsO_zYvuPWWb56 {
    --horizontal-padding: 4rem;
  }

  .Ti_7UHTcij_uY7oFppr1 {
    --top-padding: 6rem;
  }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .M_LWzogsO_zYvuPWWb56 {
    --horizontal-padding: 3rem;
  }

  .Ti_7UHTcij_uY7oFppr1 {
    --top-padding: 5rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .M_LWzogsO_zYvuPWWb56 {
    --horizontal-padding: 2rem;
  }

  .Ti_7UHTcij_uY7oFppr1 {
    --top-padding: 4rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .M_LWzogsO_zYvuPWWb56 {
    --horizontal-padding: 1rem;
  }

  .Ti_7UHTcij_uY7oFppr1 {
    --top-padding: 3rem;
    --bottom-padding: 1.5rem;
  }

  .BEJ3qVWAC5B6xyDwF8XC {
    max-width: 20rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NotFoundPageBody/NotFoundPageBody.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,wBAAsB;;EAEtB,+BAA+B;EAC/B,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,sBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAoB;AACtB;;AAEA;;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,wBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".notFoundPageContainer {\n  max-width: 800px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  min-height: 50vh;\n  padding-left: var(--horizontal-padding);\n  padding-right: var(--horizontal-padding);\n}\n\n.title {\n  --bottom-padding: 40px;\n\n  padding-top: var(--top-padding);\n  padding-bottom: var(--bottom-padding);\n  color: var(--error-404-text-color);\n}\n\n.description {\n  padding-bottom: 40px;\n  min-width: 100%;\n}\n\n.link {\n  display: inline;\n  font-size: 16px;\n}\n\n.image {\n  padding-bottom: 40px;\n}\n\n@media (--desktop-large) {\n  .notFoundPageContainer {\n    --horizontal-padding: 64px;\n  }\n\n  .title {\n    --top-padding: 96px;\n  }\n}\n\n@media (--desktop-small) {\n  .notFoundPageContainer {\n    --horizontal-padding: 48px;\n  }\n\n  .title {\n    --top-padding: 80px;\n  }\n}\n\n@media (--tablet) {\n  .notFoundPageContainer {\n    --horizontal-padding: 32px;\n  }\n\n  .title {\n    --top-padding: 64px;\n  }\n}\n\n@media (--mobile) {\n  .notFoundPageContainer {\n    --horizontal-padding: 16px;\n  }\n\n  .title {\n    --top-padding: 48px;\n    --bottom-padding: 24px;\n  }\n\n  .image {\n    max-width: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notFoundPageContainer": `M_LWzogsO_zYvuPWWb56`,
	"title": `Ti_7UHTcij_uY7oFppr1`,
	"description": `QhnOgzWcbQE7aDNH_VaU`,
	"link": `E7WhznPcFeQeAyPuNB_8`,
	"image": `BEJ3qVWAC5B6xyDwF8XC`
};
export default ___CSS_LOADER_EXPORT___;
